<template>
  <b-tab-item
    :label="label"
    :icon="icon"
    :value="id"
  >
    <section-box>
      <slot></slot>
    </section-box>
  </b-tab-item>
</template>

<script>
export default {
  name: "TabItemSection",
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String
    },
    id: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

</style>
